import { render } from "./dropzone.vue?vue&type=template&id=45fbf030"
import script from "./dropzone.vue?vue&type=script&lang=js"
export * from "./dropzone.vue?vue&type=script&lang=js"

import exportComponent from "/build/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__